import './index.css'

import React, { Component } from 'react'
import SpinnerFacebook from '../../components/utils/spinner-facebook'
import Spinner from '../../components/utils/spinner'
import { Link } from 'react-router-dom'
import axios from 'axios'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime)

class ShareComponent extends Component {
  constructor(props) {
    super(props)

    let resumeData = { hash: '', psw: '' }
    const myStorage = localStorage.getItem('resumeData')

    if (myStorage !== null) {
      resumeData = JSON.parse(myStorage)
    }

    this.state = {
      error: false,
      loading: false,
      hash: resumeData.hash,
      psw: resumeData.psw,
      onFocusHash: false,
      onFocusPsw: false,
      copied: false,
      views: 0,
      downloads: 0,
      lastView: null,
      lastDownload: null,
      loadingMetrics: false,
      validateHashPsw: false,
    }
  }

  editResume = e => {
    e.preventDefault()

    let state = this.state
    state.loading = true

    this.setState(state)

    axios
      .post(`${process.env.REACT_APP_API_URL}/resume/validateHashPsw`, {
        hashResume: this.state.hash,
        pswResume: this.state.psw,
      })
      .then(response => {
        let hash = response.data.resume
        let psw = response.data.psw

        state.loading = false
        state.hash = hash
        state.psw = psw

        let resumeData = { hash: hash, psw: psw, token: null }
        localStorage.setItem('resumeData', JSON.stringify(resumeData))

        this.setState(state)

        this.props.history.push('/edit')
      })
      .catch(err => {
        alert("You are not allowed to access or this content doesn't exist")
        state.loading = false
        state.error = true
        this.setState(state)
      })
  }

  kFormatter = num => {
    return Math.abs(num) > 999
      ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + 'k'
      : Math.sign(num) * Math.abs(num)
  }

  getMetrics = () => {
    let state = this.state
    state.loadingMetrics = true

    this.setState(state)

    axios
      .post(`${process.env.REACT_APP_API_URL}/resume/getMetrics`, {
        hashResume: this.state.hash,
        pswResume: this.state.psw,
      })
      .then(response => {
        state.loadingMetrics = false
        state.views = response.data.views
        state.downloads = response.data.downloads

        if (response.data.lastView) {
          state.lastView = dayjs(response.data.lastView).fromNow()
        }
        if (response.data.lastDownload) {
          state.lastDownload = dayjs(response.data.lastDownload).fromNow()
        }

        this.setState(state)
      })
      .catch(err => {
        state.loadingMetrics = false
        this.setState(state)
      })
  }

  componentDidMount() {
    axios
      .post(`${process.env.REACT_APP_API_URL}/resume/validateHashPsw`, {
        hashResume: this.state.hash,
        pswResume: this.state.psw,
      })
      .then(response => {
        this.setState({ validateHashPsw: true })
        this.getMetrics()
      })
      .catch(err => {
        this.props.history.push('/')
      })
  }

  handleChange = e => {
    const value = e.target.value
    const id = e.target.id
    let state = this.state
    state[id] = value

    this.setState(state)

    let resumeData = { hash: state.hash, psw: state.psw, token: null }
    localStorage.setItem('resumeData', JSON.stringify(resumeData))
  }

  contentEditButton = () => {
    if (this.state.loading) {
      return <SpinnerFacebook />
    }

    return <div className="lds-facebook">Edit</div>
  }

  onFocus = e => {
    const id = e.target.id
    let state = this.state

    if (id === 'hash') {
      state.onFocusHash = true
    }

    if (id === 'psw') {
      state.onFocusPsw = true
    }

    this.setState(state)
  }

  onBlur = e => {
    const id = e.target.id
    let state = this.state
    if (id === 'hash') {
      state.onFocusHash = false
    }

    if (id === 'psw') {
      state.onFocusPsw = false
    }

    this.setState(state)
  }

  copy = () => {
    navigator.clipboard.writeText(`${process.env.REACT_APP_API_SERVE_URL}/${this.state.hash}`)

    clearInterval(this.refreshTimeID)

    let state = this.state

    state.copied = true

    this.setState(state)

    this.refreshTimeID = setInterval(() => this.backToCopy(), 2000)
  }

  backToCopy = () => {
    clearInterval(this.refreshTimeID)
    let state = this.state

    state.copied = false
    this.setState(state)
  }

  showCopyLabel = () => {
    if (this.state.copied) return 'Copied!'

    return 'Copy'
  }

  componentWillUnmount() {
    clearInterval(this.refreshTimeID)
  }

  showDomain = () => {
    const domain = new URL(process.env.REACT_APP_API_SERVE_URL)

    return domain.host
  }

  showForm = () => {
    return (
      <div className="create-home">
        <a
          href="https://makeresume.co"
          target="_blank"
          rel="noreferrer"
          title="Go to makeresume.co"
          className="link-home"
        >
          <img src="/logo.png" alt="makeresume.co" className="logo-home" />
        </a>
        <div className="create-home-container right-panel-active form-share" id="container">
          <div className="form-container sign-up-container form-share">
            <form action="#">
              <h1>Edit Resume</h1>
              <span>Please, save this data!</span>
              <input
                type="text"
                disabled={true}
                placeholder="Resume"
                id="hash"
                value={this.state.hash}
                onChange={this.handleChange}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
              />
              <div
                className={`text-input-border-bottom ${this.state.onFocusHash ? 'active' : ''}`}
              />

              <input
                type="text"
                disabled={true}
                placeholder="Password"
                id="psw"
                value={this.state.psw}
                onChange={this.handleChange}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
              />
              <div
                className={`text-input-border-bottom ${this.state.onFocusPsw ? 'active' : ''}`}
              />

              <button disabled={this.state.loading} onClick={this.editResume}>
                {this.contentEditButton()}
              </button>

              <div className="create-link-share-page">
                <Link to="/">Or create a new one!</Link>
              </div>
            </form>
          </div>

          <div className="overlay-container form-share">
            <div className="overlay">
              <div className="overlay-panel overlay-left">
                <h1>Share Your Resume</h1>
                <div style={{ display: 'flex' }}>
                  <p className="form-share url">
                    <a
                      className={`${this.state.copied ? 'copied' : ''}`}
                      href={`${process.env.REACT_APP_API_SERVE_URL}/${this.state.hash}`}
                      target="_blank"
                      rel="noreferrer"
                      title="Your Resume :)"
                    >
                      {`${this.showDomain()}/${this.state.hash}`}
                    </a>
                  </p>
                  <p className="form-share copy" onClick={this.copy}>
                    {this.showCopyLabel()}
                  </p>
                </div>
                <div
                  style={{
                    height: '200px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '70%',
                  }}
                >
                  <div>
                    <h4>Views</h4>
                    <span style={{ fontSize: '80px' }} title={this.state.views}>
                      {this.kFormatter(this.state.views)}
                    </span>
                    <p>
                      Last view <br />
                      {this.state.lastView}
                    </p>
                  </div>
                  <div>
                    <h4>Downloads</h4>
                    <span style={{ fontSize: '80px' }} title={this.state.downloads}>
                      {this.kFormatter(this.state.downloads)}
                    </span>
                    <p>
                      Last Download <br />
                      {this.state.lastDownload}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    if (this.state.validateHashPsw) {
      return this.showForm()
    } else {
      return <Spinner />
    }
  }
}

export default ShareComponent
